// extracted by mini-css-extract-plugin
export default {"listItem":"TaxCardList_listItem__GBltz"};